import global from "../global.js";

import Style from "../utils/Style.js";

import Transform from "./Transform.js";

const d3 = global.d3;

// const log = global.log.getLogger("f_mtac.scene.object_handle");

const HANDLE_SIZE = () => global.app.scale.wb / 8;
const HANDLE_HIT_BOX_SIZE = () => (1 * global.app.scale.wb) / 3;

const ObjectHandle = function ({x, y, color}) {
    let group = d3.create("svg:g"); //.attr("transform",`translate(${x},${y})`);
    group.append("circle").attr("class", "object_handle").attr("cx", x).attr("cy", y).attr("r", HANDLE_SIZE()).attr("fill", color);
    group.append("circle").attr("class", "object_handle_hit_box").attr("cx", x).attr("cy", y).attr("r", HANDLE_HIT_BOX_SIZE()).attr("fill", "transparent");
    return group;
};

const style = new Style();

ObjectHandle.transform = new Transform({k: 1});
ObjectHandle.transform.on_scale(() => {
    style.rule_set(
        "scene_object_handle_scale",
        `
        .object_handle {
            r: calc(1 / 8 * var(--wb) * var(--scale-factor));
        }
        .object_handle_hit_box {
            r: calc(1 / 3 * var(--wb) * var(--scale-factor));
        }
    `
    );
});

ObjectHandle.hide = () => {
    style.rule_set(
        "scene_object_handle_display",
        `
        .object_handle, .object_handle_hit_box {
            display : none !important;
        }
    `
    );
};

ObjectHandle.show = () => {
    style.rule_set(
        "scene_object_handle_display",
        `
        .object_handle, .object_handle_hit_box {
            display : block !important;
        }
    `
    );
};

ObjectHandle.hide();

export default ObjectHandle;
